import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import store from '../store'
import parameters from './parameters'

const initUserJwt = () => {
    const storedUserToken = store.state.userToken
    if (storedUserToken) {
        Vue.axios.defaults.headers.common['Authorization'] = `Token ${storedUserToken}`
    }
}

const ApiService = {
    init(contextKey) {
        Vue.use(VueAxios, axios)
        Vue.axios.defaults.baseURL = parameters.api.baseUrl
        if (contextKey) {
            Vue.axios.defaults.baseURL = 'MP' === contextKey
                ? parameters.api.baseUrlContextPattern.replace('{context}.', '')
                : parameters.api.baseUrlContextPattern.replace('{context}', contextKey)
        }
    },

    getPlaceContext() {
        return Vue.axios.get(`/2/place-context.json`)
    },

    fetchPlaces() {
        return Vue.axios.get(`/2/places.json`)
    },

    getSession() {
        initUserJwt()
        return Vue.axios.get('/1/users/session.json')
    },

    getWorkshops(params = {}) {
        const workshopsLocales = store.state.workshopsLocales.map(locale => `locales[]=${locale}`).join('&')

        let url = `/1/workshops.json?context_key=${store.state.placeContext.key}&temporalScope=futures&locationScope=place&${workshopsLocales}&expand[]=workshop.place`

        if (params.placeCode) {
            url += `&placeCode=${params.placeCode}`
        }

        if (params.placeCodes && params.placeCodes.length > 0) {
            url += '&' + params.placeCodes.map(code => `placeCodes[]=${code}`).join('&')
        }

        if (params.date) {
            url += `&date=${params.date}`
        }

        if (params.search) {
            url += `&q=${params.search}`
        }

        return Vue.axios.get(url)
    },

    getCurrentUserWorkshops() {
        initUserJwt()
        return Vue.axios.get('/1/workshops/mine.json?expand[]=workshop.place')
    },

    loginOrRegister(userData) {
        const loginOrRegisterData = {
            locale: userData.locale,
            email: userData.email,
            firstname: userData.firstname || undefined,
            lastname: userData.lastname || undefined,
            address: userData.address || undefined,
            phone: userData.phone || undefined,
            loyalty_card_number: userData.loyalty_card_number || undefined,
        }

        return Vue.axios.post(`/1/workshops/login-register.json`, loginOrRegisterData)
    },

    registerToWorkshop(workshopUuid, guests = [], successUrl = null, cancelUrl = null) {
        initUserJwt()
        const data = { guests }

        // Add payment return URLs if provided
        if (successUrl) {
            data.success_url = successUrl
        }
        if (cancelUrl) {
            data.cancel_url = cancelUrl
        }

        return Vue.axios.post(`/1/workshops/${workshopUuid}/register.json`, data)
    },

    unregisterToWorkshop(workshopUuid, customerPayload) {
        return Vue.axios.post(`/1/workshops/${workshopUuid}/unregister.json`, {
            cI: customerPayload.customerId,
            cT: customerPayload.customerOCT,
        })
    },

    getPrivateWorkshop(workshopUuid, token = null) {
        const tokenQuery = token ? `token=${encodeURIComponent(token)}&` : ''
        return Vue.axios.get(`/1/public/workshops/${workshopUuid}.json?${tokenQuery}expand[]=workshop.place`)
    },

    getWorkshopDays(workshopUuid, token = null) {
        const tokenQuery = token ? `?token=${encodeURIComponent(token)}` : ''
        return Vue.axios.get(`/1/public/workshops/${workshopUuid}/days.json${tokenQuery}`)
    },

    getWorkshopDaySessions(workshopUuid, date, token = null) {
        const tokenQuery = token ? `?token=${encodeURIComponent(token)}` : ''
        return Vue.axios.get(`/1/public/workshops/${workshopUuid}/days/${date}/sessions.json${tokenQuery}`)
    },
}

export default ApiService
